import { useEffect, useState } from 'react';
import SiteLayout from '@/components/feature/SiteLayout';
import FeaturedCarousel from '@/pages/home/components/FeaturedCarousel';
import LiveSidebar from '@/pages/home/components/LiveSidebar';
import LeagueEntries from '@/pages/home/components/LeagueEntries';
import LatestMatches from '@/pages/home/components/LatestMatches';
import AboutIntro from '@/pages/home/components/AboutIntro';
import { liveAndUpcoming, matches, setPageMeta, siteInfo, sortByTime } from '@/lib/site';

const featured = liveAndUpcoming(matches).slice(0, 4);
const totalLive = matches.filter((item) => item.status === 'live').length;
const totalUpcoming = matches.filter((item) => item.status === 'upcoming').length;

export default function Home() {
  const [tab, setTab] = useState('all');

  useEffect(() => {
    setPageMeta(siteInfo.title, siteInfo.description, siteInfo.keywords);
  }, []);

  return (
    <SiteLayout>
      <section className="w-full bg-background-50 border-b border-background-200">
        <div className="w-full px-4 md:px-6 lg:px-8 pt-6 pb-8 md:pt-8 md:pb-10">
          <div className="grid grid-cols-1 xl:grid-cols-12 gap-4 md:gap-5">
            <div className="xl:col-span-8 min-w-0">
              <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl leading-tight text-foreground-950">
                    篮球直播 · 实时篮球赛事在线直播平台
                  </h1>
                  <p className="mt-2 text-sm text-foreground-600">
                    今日 <span className="text-accent-700 font-medium">{totalLive}</span> 场直播进行中，
                    <span className="text-primary-700 font-medium"> {totalUpcoming} </span>
                    场即将开赛 · 覆盖 NBA / CBA / 国际赛
                  </p>
                </div>
                <div className="hidden md:flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-calendar-line" />
                    {sortByTime(matches)[0]?.dateLabel}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-signal-tower-line" />
                    高清信号演示
                  </span>
                </div>
              </div>
              <FeaturedCarousel items={featured} />
            </div>
            <div className="xl:col-span-4 min-w-0">
              <LiveSidebar />
            </div>
          </div>
        </div>
      </section>

      <div className="w-full px-4 md:px-6 lg:px-8 pt-8 md:pt-12 pb-12 md:pb-14 space-y-10 md:space-y-12">
        <LeagueEntries />
        <LatestMatches active={tab} onChange={setTab} />
        <AboutIntro />
      </div>
    </SiteLayout>
  );
}